import "core-js/modules/es.string.link.js";
export var buttonPortalTokens = {
  defaultSize: "m",
  defaultVariant: "secondary",
  fontWeight: 400,
  letterSpacing: "normal",
  borderWidth: 0,
  focusBoxShadowAttrs: "0 0 3px 1px",
  focusColor: function focusColor(_ref) {
    var color = _ref.color;
    return color.border.focus.base;
  },
  focusHoverColor: function focusHoverColor(_ref2) {
    var color = _ref2.color;
    return color.border.focus.hover;
  },
  sizes: {
    l: {
      radius: 10,
      iconSize: 30,
      paddingX: 24,
      paddingY: 12,
      iconMarginOut: 14,
      iconMarginIn: 6,
      iconOnlyMargin: 9,
      iconMinHeight: 48
    },
    m: {
      radius: 8,
      iconSize: 24,
      paddingX: 22,
      paddingY: 10,
      iconMarginOut: 13,
      iconMarginIn: 6,
      iconOnlyMargin: 8,
      iconMinHeight: 40
    },
    s: {
      radius: 6,
      iconSize: 18,
      paddingX: 20,
      paddingY: 7,
      iconMarginOut: 11,
      iconMarginIn: 6,
      iconOnlyMargin: 7,
      iconMinHeight: 32
    }
  },
  variants: {
    primary: {
      base: function base(_ref3) {
        var color = _ref3.color;
        return color.importance.primary.base;
      },
      textBase: function textBase(_ref4) {
        var color = _ref4.color;
        return color.text.white.base;
      },
      hover: function hover(_ref5) {
        var color = _ref5.color;
        return color.importance.primary.hover;
      },
      textHover: function textHover(_ref6) {
        var color = _ref6.color;
        return color.text.white.base;
      },
      active: function active(_ref7) {
        var color = _ref7.color;
        return color.importance.primary.active;
      },
      textActive: function textActive(_ref8) {
        var color = _ref8.color;
        return color.text.white.base;
      },
      opacity: 0.5
    },
    secondary: {
      base: function base(_ref9) {
        var color = _ref9.color;
        return color.importance.secondary.base;
      },
      textBase: function textBase(_ref10) {
        var color = _ref10.color;
        return color.text.black.base;
      },
      hover: function hover(_ref11) {
        var color = _ref11.color;
        return color.importance.secondary.hover;
      },
      textHover: function textHover(_ref12) {
        var color = _ref12.color;
        return color.text.black.base;
      },
      active: function active(_ref13) {
        var color = _ref13.color;
        return color.importance.secondary.active;
      },
      textActive: function textActive(_ref14) {
        var color = _ref14.color;
        return color.text.black.base;
      },
      opacity: 0.5
    },
    success: {
      base: function base(_ref15) {
        var color = _ref15.color;
        return color.importance.success.base;
      },
      textBase: function textBase(_ref16) {
        var color = _ref16.color;
        return color.text.white.base;
      },
      hover: function hover(_ref17) {
        var color = _ref17.color;
        return color.importance.success.hover;
      },
      textHover: function textHover(_ref18) {
        var color = _ref18.color;
        return color.text.white.base;
      },
      active: function active(_ref19) {
        var color = _ref19.color;
        return color.importance.success.active;
      },
      textActive: function textActive(_ref20) {
        var color = _ref20.color;
        return color.text.white.base;
      },
      opacity: 0.5
    },
    attention: {
      base: function base(_ref21) {
        var color = _ref21.color;
        return color.importance.attention.base;
      },
      textBase: function textBase(_ref22) {
        var color = _ref22.color;
        return color.text.white.base;
      },
      hover: function hover(_ref23) {
        var color = _ref23.color;
        return color.importance.attention.hover;
      },
      textHover: function textHover(_ref24) {
        var color = _ref24.color;
        return color.text.white.base;
      },
      active: function active(_ref25) {
        var color = _ref25.color;
        return color.importance.attention.active;
      },
      textActive: function textActive(_ref26) {
        var color = _ref26.color;
        return color.text.white.base;
      },
      opacity: 0.5
    },
    danger: {
      base: function base(_ref27) {
        var color = _ref27.color;
        return color.importance.danger.base;
      },
      textBase: function textBase(_ref28) {
        var color = _ref28.color;
        return color.text.white.base;
      },
      hover: function hover(_ref29) {
        var color = _ref29.color;
        return color.importance.danger.hover;
      },
      textHover: function textHover(_ref30) {
        var color = _ref30.color;
        return color.text.white.base;
      },
      active: function active(_ref31) {
        var color = _ref31.color;
        return color.importance.danger.active;
      },
      textActive: function textActive(_ref32) {
        var color = _ref32.color;
        return color.text.white.base;
      },
      opacity: 0.5
    },
    transparency: {
      base: function base(_ref33) {
        var color = _ref33.color;
        return color.importance.transparency.base;
      },
      textBase: function textBase(_ref34) {
        var color = _ref34.color;
        return color.text.link.base;
      },
      hover: function hover(_ref35) {
        var color = _ref35.color;
        return color.importance.transparency.hover;
      },
      textHover: function textHover(_ref36) {
        var color = _ref36.color;
        return color.text.link.hover;
      },
      active: function active(_ref37) {
        var color = _ref37.color;
        return color.importance.transparency.active;
      },
      textActive: function textActive(_ref38) {
        var color = _ref38.color;
        return color.text.link.hover;
      },
      opacity: 0.5
    },
    selected: {
      base: function base(_ref39) {
        var color = _ref39.color;
        return color.importance.secondary.selected;
      },
      textBase: function textBase(_ref40) {
        var color = _ref40.color;
        return color.text.black.base;
      },
      hover: function hover(_ref41) {
        var color = _ref41.color;
        return color.importance.secondary.selected;
      },
      textHover: function textHover(_ref42) {
        var color = _ref42.color;
        return color.text.black.base;
      },
      active: function active(_ref43) {
        var color = _ref43.color;
        return color.importance.secondary.selected;
      },
      textActive: function textActive(_ref44) {
        var color = _ref44.color;
        return color.text.black.base;
      },
      opacity: 0.5
    }
  }
};